import * as mime from 'mime-types';

import { File } from './../generated/graphql';

class FileHandler {
  public downloadFile = (file: Pick<File, 'id' | 'url' | 'mimeType'>) => {
    if (typeof window === 'undefined') {
      return;
    }

    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';

    tempLink.href = `${file.url}?download=true`;

    const extension = mime.extension(file.mimeType);

    tempLink.setAttribute('download', `${file.id}.${extension}`);

    // for avoid desktop safari pop up blocking
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  };
}

export default FileHandler;
